import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
// import Item from './Item';
import FormInput from '../../components/Input/FormInput';
import useInput from '../../hooks/use-input';
import {SEGURO_VALIDATION} from '../../constants/form/validations';
import * as CONSTANTS from '../../constants/form/request-form';
// import ChangeWords from '../../utils/changeWords';

const SeguroFormIndex = ({
  cacheCredit,
  loanId,
  onSubmit: onParentSubmit,
  submit: parentSubmit,
}) => {
  const methods = useFormContext();
  if (!methods) throw new Error('SeguroFormIndex must be used within FormProvider');

  const {
    handleSubmit,
    formState: { errors },
    control,
    getValues,
    register,
    watch,
  } = methods;

  const { InputProps, setLoading } = useInput({
    errors,
    getValues,
    register,
    control,
    validations: SEGURO_VALIDATION,
  });

  // const [attachments, setAttachments] = useState({});
  const watchEnfermedad = watch('enfermedad');
  const watchTratamiento = watch('tratamiento'); 
  const watchDiscapacidad = watch('discapacidad'); 
  // const setAttachment = (name, value) =>
  //   setAttachments((current) => ({ ...current, [name]: value }));

  // const colSpans = {
  //   1: 'xl:col-span-1 lg:col-span-2 col-span-1',
  //   2: 'xl:col-span-2 lg:col-span-2 col-span-1',
  //   3: 'xl:col-span-3 lg:col-span-4 col-span-1',
  //   4: 'xl:col-span-4 lg:col-span-4 col-span-1',
  // };
  // const [formValues, setFormValues] = useState({
  //   nombres: watch('nombres'),
  //   apellidos: watch('apellidos'),
  //   correo_electronico: watch('correo_electronico'),
  // });

  // const handleChangeToUpperCase = (event) => {
  //   const { name, value } = event.target;
  //   setFormValues((prevValues) => ({
  //     ...prevValues,
  //     [name]: ChangeWords.changeFirstInUpperCase(value),
  //   }));
  // };

  // const handleChangeToLowerCase = (event) => {
  //   const { name, value } = event.target;
  //   setFormValues((prevValues) => ({
  //     ...prevValues,
  //     [name]: ChangeWords.ChangeAllInLowerCase(value),
  //   }));
  // };
  const onSubmit = async (values) => {
    setLoading( false);
    await onParentSubmit({
      university: cacheCredit.universidad,
      loanId,
      values,
      // attachments: Object.keys(attachments).map((key) => ({
      //   name: key,
      //   key: attachments[key],
      // })),
    });
  };

  useEffect(() => {
    if (parentSubmit) handleSubmit(onSubmit)();
  }, [parentSubmit]);

  return (
    <form className="my-4 space-y-4">
      
        <section >
          <h2 className="pb-4 ">1. ¿Cuál es su peso en kilos?</h2>
          <div className="grid grid-cols-1 gap-6 lg:grid-cols-4">
          <FormInput
            {...InputProps('peso')}
            placeholder="Peso"
            type="document"
            className="col-span-4 lg:col-span-12"
            // value={formValues.nombres}
            // onChange={handleChangeToUpperCase}
          />
          </div>

          <h2 className="pb-4  mt-5">¿Cuál es su estatura en centímetros?</h2>
          <div className="grid grid-cols-1 gap-6 lg:grid-cols-4">
          <FormInput
            {...InputProps('estatura')}
            placeholder="170"
            type="document"
            className="col-span-4 lg:col-span-12"
            // value={formValues.nombres}
            // onChange={handleChangeToUpperCase}
          />
          </div>

          <h2 className="pb-4  mt-5">
            2. Según su leal saber y entender, ¿tiene o ha tenido algún padecimiento del corazón, 
            neurológico, vascular o ha padecido enfermedades como Hipertensión Arterial, Cáncer, Diabetes, 
            Asma, trombosis o derrames cerebrales, anemias, enfermedades pulmonares, Artritis Reumatoidea, 
            Cirrosis, enfermedades del hígado o de los riñones, insuficiencia renal, tumores, Leucemia o Linfoma, 
            trastornos inmunológicos o del colágeno, Lupus, enfermedades mentales u otras?
          </h2>
          <div className="grid grid-cols-2 gap-6 lg:grid-cols-12">
          <FormInput
            {...InputProps('enfermedad')}
            placeholder="Seleccione"
            type="select"
            options={CONSTANTS.BINARIO}
            className="col-span-4 lg:col-span-3"
          />
          {watchEnfermedad?.toString() === 'true' && (
            <>
            <FormInput
              {...InputProps('enfermedadCual')}
              placeholder="¿Cuál?"
              type="text"
              className="col-span-4 lg:col-span-3"
            />
            <FormInput
              {...InputProps('enfermedadAno')}
              placeholder="Año de detección"
              type="text"
              className="col-span-4 lg:col-span-3"
            />
            <FormInput
              {...InputProps('enfermedadMas')}
              placeholder="Amplía los detalles de las enfermedades, separadas por coma y año de detección."
              type="text"
              className="col-span-12 lg:col-span-12"
            />
            </>
          )}
          
          </div>

          <h2 className="pb-4  mt-5">
            3. ¿Le han detectado la presencia de anticuerpos contra el virus V.I.H. productor del SIDA?
          </h2>
          <div className="grid grid-cols-1 gap-6 lg:grid-cols-4">
          <FormInput
            {...InputProps('vih')}
            placeholder="Seleccione"
            type="select"
            options={CONSTANTS.BINARIO}
            className="col-span-4 lg:col-span-1"
          />
          </div>

          <h2 className="pb-4  mt-5">
            4. ¿Se encuentra actualmente en exámenes, estudios, investigación o le han indicado la necesidad 
            de alguna cirugía o tratamiento que no se ha realizado aún?
          </h2>
          <div className="grid grid-cols-1 gap-6 lg:grid-cols-4">
          <FormInput
            {...InputProps('tratamiento')}
            placeholder="Seleccione"
            type="select"
            options={CONSTANTS.BINARIO}
            className="col-span-4 lg:col-span-1"
          />
          {watchTratamiento?.toString() === 'true' && (
            <>
              <FormInput
                {...InputProps('tratamientoCual')}
                placeholder="¿Cuál?"
                type="text"
                className="col-span-4 lg:col-span-3"
              />
            </>
          )}
          </div>

          <h2 className="pb-4  mt-5">
            5. ¿Tiene algún tipo de discapacidad, incapacidad o limitación física o mental?
          </h2>
          <div className="grid grid-cols-1 gap-6 lg:grid-cols-4">
          <FormInput
            {...InputProps('discapacidad')}
            placeholder="Seleccione"
            type="select"
            options={CONSTANTS.BINARIO}
            className="col-span-4 lg:col-span-1"
          />
          {watchDiscapacidad?.toString() === 'true' && (
            <>
              <FormInput
                {...InputProps('discapacidadCual')}
                placeholder="¿Cuál?"
                type="text"
                className="col-span-4 lg:col-span-3"
              />
            </>
          )}
          </div>

          
          <h2 className="pb-4  mt-5">
            6. ¿Es usted una persona políticamente expuesta?
          </h2>
          <div className="grid grid-cols-1 gap-6 lg:grid-cols-4">
          <FormInput
            {...InputProps('expuesta')}
            placeholder="Seleccione"
            type="select"
            options={CONSTANTS.BINARIO}
            className="col-span-4 lg:col-span-1"
          />
          </div>
          
          <h2 className="pb-4  mt-5">
            7. ¿Existe algún vínculo entre usted y una persona considerada expuesta políticamente?
          </h2>
          <div className="grid grid-cols-1 gap-6 lg:grid-cols-4">
          <FormInput
            {...InputProps('expuestaPersona')}
            placeholder="Seleccione"
            type="select"
            options={CONSTANTS.BINARIO}
            className="col-span-4 lg:col-span-1"
          />
          </div>

        </section>
  
    </form>
  );
};

export default SeguroFormIndex;
